import jsonData from "./booking_origin.json";
import Types from '../Types.mjs'

class BookingOrigin extends Types {
    constructor(params = {}) {
      super({TYPES: jsonData});
    }
};

export default BookingOrigin = new BookingOrigin();